import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { DetailedIconUnlock } from '@zillow/constellation';
import { Button, ButtonGroup, Heading, Modal, TextButton } from '@zillow/constellation-10';

import { RMWContext } from '../../../providers/RMWContext';
import IdVerificationContent from './components/IdVerificationContent';
import { ENTRY_POINT_PATH } from '../../../containers/RentGuaranteePage/constants';

const propTypes = {
  applicationsUrlPath: PropTypes.string.isRequired,
};
const defaultProps = {};

const IdVerificationOnboardingModal = ({ applicationsUrlPath }) => {
  const history = useHistory();
  const location = useLocation();

  const contextType = useContext(RMWContext);
  const { paths } = contextType;

  const urlSearchString = new URLSearchParams({
    ...location.search,
    verifyIdentitySuccess: 'true',
  }).toString();
  const queryString = urlSearchString ? `?${urlSearchString}` : '';

  const handleVerifyIdentity = () => {
    history.push({
      pathname: `${paths.idVerification}`,
      state: {
        from: ENTRY_POINT_PATH.DASHBOARD_PAGE,
        applicationsUrlPath: `${applicationsUrlPath}${queryString}`,
      },
      search: window.location.search,
    });
  };

  return (
    <Modal
      multiModalTriggerId="IdVerificationOnboardingModal"
      header={
        <Heading level={2} textStyle="heading-xs">
          Identity verification
        </Heading>
      }
      body={
        <>
          <DetailedIconUnlock size="md" />
          <Heading level={4} css={{ marginY: '400' }}>
            Verify your identity now to view applications
          </Heading>
          <IdVerificationContent />
        </>
      }
      footer={
        <ButtonGroup aria-label="identity verification choices">
          <Modal.Close>
            <TextButton tone="brand">Cancel</TextButton>
          </Modal.Close>
          <Button tone="brand" emphasis="filled" onClick={handleVerifyIdentity} data-testid="verify-identity-button">
            Verify your identity
          </Button>
        </ButtonGroup>
      }
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

IdVerificationOnboardingModal.propTypes = propTypes;
IdVerificationOnboardingModal.defaultProps = defaultProps;

export default IdVerificationOnboardingModal;
